import { sortBy } from "lodash";

import {
  GetLimitRequestPaymastersQuery,
  LimitRequestPaymasterApprovalStatus,
} from "../../graphql/generated.ts";
import { toHumanReadable } from "../../utils/string.ts";

export type LimitRequestPaymaster =
  GetLimitRequestPaymastersQuery["limitRequestPaymasters"][0];

export const limitRequestPaymasterStatusOptions = sortBy(
  Object.values(LimitRequestPaymasterApprovalStatus).map((value) => {
    return {
      value,
      label: toHumanReadable(value),
    };
  }),
  "label"
);
